import './alert.scss'
import { useLocal } from '@/i18n/LocalContext'
import { useStore } from '@/store'
import CommonModal from '../CommonModal/CommonModal'
import { logout } from '@/request/utils'
import { useEffect, useMemo } from 'react'
import { Handler } from 'mitt'
import { emitter } from '@/emitter'

export default function Alert() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const open = state.alertData.open
  const freeze = state.alertData.freeze
  const resolveText = state.alertData.resolveText
  const rejectText = state.alertData.rejectText
  const btnColor = state.alertData.btnColor
  const content = state.alertData.content
  const hint = state.alertData.hint
  const showLogoutBtn = state.alertData.showLogoutBtn && !window.inSDK
  const resolveClose = state.alertData.resolveClose
  const rejectClose = state.alertData.rejectClose
  const onResolve = state.alertData.onResolve
  const onReject = state.alertData.onReject

  const resolveTextkey = useMemo(
    () => (resolveText === $t('切换账号') ? 'switch-account' : ''),
    [resolveText]
  )

  const rejectTextkey = useMemo(
    () => (rejectText === $t('退出登录') ? 'logout' : ''),
    [rejectText]
  )

  useEffect(() => {
    const _handle: Handler<AlertEvent> = (e) => {
      dispatch({
        type: 'setAlertData',
        data: {
          ...e,
        },
      })
    }

    const _cancel = () => {
      emitter.off('alert', _handle)
    }

    emitter.on('alert', _handle)

    return _cancel
  }, [])

  const close = () => {
    if (freeze) return

    dispatch({
      type: 'setAlertData',
      data: {
        open: false,
        btnColor: 'normal',
        content: '',
      },
    })
  }

  const resolve = () => {
    onResolve instanceof Function && onResolve()
    close()
  }

  const reject = () => {
    onReject instanceof Function && onReject()
    close()
  }

  const handleClose = () => {
    if (resolveClose) {
      return resolve()
    }

    if (rejectClose) {
      return reject()
    }

    close()
  }

  const _logout = () => {
    close()
    logout($t('确认退出登录？'))
  }

  return (
    <CommonModal
      open={open}
      title={$t('提示')}
      type="alert"
      length="short"
      onClose={handleClose}
    >
      {[
        [
          <p
            key="1"
            className="common-modal-text"
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={{ __html: content }}
          ></p>,
          hint ? (
            <p key="4" className="common-modal-hint">
              {hint}
            </p>
          ) : null,
          <a
            key="3"
            className="common-modal-logout"
            style={{ display: showLogoutBtn ? 'block' : 'none' }}
            onClick={_logout}
          >
            {$t('退出登录')}
          </a>,
        ],
        [
          <a
            key="22"
            className="common-modal-reject"
            style={{ display: rejectText ? 'flex' : 'none' }}
            data-key={rejectTextkey}
            onClick={reject}
          >
            <span>{rejectText}</span>
          </a>,
          <a
            key="21"
            className={`common-modal-btn${
              !btnColor ? '' : ` common-modal-btn--${btnColor}`
            }`}
            data-key={resolveTextkey}
            onClick={resolve}
          >
            <span>{!resolveText ? $t('确定') : resolveText}</span>
          </a>,
        ],
      ]}
    </CommonModal>
  )
}
